

































































































































import { Component, Vue } from 'vue-property-decorator'
import { Cancelable } from 'lodash'
import debounce from 'lodash/debounce'

import VueLoading from '../components/Loading.vue'
import GenericForm from '../components/GenericForm.vue'

export const stateMerge = function<T extends Record<string, any>>(
  state: T,
  value: T,
  propName: string | null = null,
  ignoreNull: boolean = false,
) {
  if (
    Object.prototype.toString.call(value) === '[object Object]' &&
    (propName == null || state.hasOwnProperty(propName))
  ) {
    const o = propName == null ? state : state[propName]
    for (var prop in value) {
      stateMerge(o, value[prop], prop, ignoreNull)
    }
    return
  }
  if (propName && (!ignoreNull || value !== null))
    Vue.set(state, propName, value)
}

import {
  questions,
  profile,
  dataConsent,
  emailRegexp,
  referenceReturning,
  getPercentComplete,
  getAnswersObject,
} from '../data/application'
import { db, auth } from '../utils/firebase'

@Component({
  components: {
    GenericForm,
    VueLoading,
  },
})
export default class Dashboard extends Vue {
  dataConsent = dataConsent
  application = questions
  applicationAnswers: Record<string, string> = {}
  profile = profile
  profileAnswers: Record<string, string> = {}
  reference = referenceReturning
  referenceAnswers: Record<string, string> = {}

  loading = true
  user: null | firebase.User = null

  showForm = ''

  trans(name: string) {
    return {
      name: this.$style[name],
      'enter-class': this.$style[`${name}-enter`],
      'enter-active-class': this.$style[`${name}-enter-active`],
      'enter-to-class': this.$style[`${name}-enter-to`],
      'leave-class': this.$style[`${name}-leave`],
      'leave-active-class': this.$style[`${name}-leave-active`],
      'leave-to-class': this.$style[`${name}-leave-to`],
    }
  }

  get validProfile() {
    if (!this.profileAnswers) return false
    return getPercentComplete(this.profile, this.profileAnswers) === 100
  }

  async mounted() {
    try {
      auth.onAuthStateChanged(async user => {
        if (user) {
          this.user = user

          const answersData = await db
            .collection('users')
            .doc(this.user.uid)
            .collection('applications')
            .doc('2020')
            .get()

          const referenceData = await db
            .collection('users')
            .doc(this.user.uid)
            .collection('references')
            .doc('2020')
            .get()

          const profileData = await db
            .collection('users')
            .doc(this.user.uid)
            .get()

          this.profileAnswers = {
            ...getAnswersObject(this.profile),
            ...getAnswersObject(this.dataConsent),
            ...profileData.data(),
          }
          this.referenceAnswers = {
            ...getAnswersObject(this.reference),
            ...referenceData.data(),
          }
          this.applicationAnswers = {
            ...getAnswersObject(this.application),
            ...answersData.data(),
          }

          this.loading = false
        } else {
          this.$router.push('/')
        }
      })
    } catch (e) {
      // console.error(e)
    }
  }

  debouncers: WeakMap<
    firebase.firestore.DocumentReference,
    ((answer: Record<string, string>) => Promise<void>) & Cancelable
  > = new WeakMap()

  setAnswer = (collection: firebase.firestore.DocumentReference) => (
    answer: Record<string, string>,
  ) => collection.set(answer, { merge: true })

  updateAnswers(
    collection: firebase.firestore.DocumentReference | null,
    answerSet: Record<string, string>,
    newValues: Record<string, string>,
  ) {
    stateMerge(answerSet, newValues)
    if (!collection) return
    if (!this.debouncers.has(collection)) {
      this.debouncers.set(
        collection,
        debounce(this.setAnswer(collection), 500, { leading: true }),
      )
    }
    const debouncer = this.debouncers.get(collection)
    if (!debouncer) return
    debouncer(answerSet)
  }

  get validReference() {
    return (
      this.$route.name === 'reference' &&
      this.$route.params.email &&
      emailRegexp.test(this.$route.params.email)
    )
  }

  get isConsented() {
    return this.profileAnswers.storeDetails === 'Yes'
  }

  get applicationCollection() {
    if (!this.user) return null
    return db
      .collection('users')
      .doc(this.user.uid)
      .collection('applications')
      .doc('2020')
  }

  get referenceCollection() {
    if (!this.user) return null
    if (!this.$route.params.email || emailRegexp.test(this.$route.params.email))
      return null
    return db
      .collection('users')
      .doc(this.user.uid)
      .collection('references')
      .doc('2020')
  }

  get profileCollection() {
    if (!this.user) return null
    return db.collection('users').doc(this.user.uid)
  }

  logout() {
    auth.signOut()
  }
}
